import * as moment from "moment";

import { Injectable } from "@angular/core";

import { HeaderInterceptorService } from "src/app/interceptors/header-interceptor";
declare var $: any;

@Injectable()
export class SalesService {
  constructor(private customAxios: HeaderInterceptorService) {}

  /**
   * @name getAllCustomerTypes
   * @returns Promise
   * @description fetch all Customer Type
   */

  getAllCustomerTypes() {
    return this.customAxios.get(`CustomerType/GetAllCustomerTypes`);
  }

  /**
   * @name GetAllUrgencyTypes
   * @returns Promise
   * @description fetch all Urgency Types
   */

  getAllUrgencyTypes() {
    return this.customAxios.get(`UrgencyType/GetAllUrgencyTypes`);
  }

  /**
   * @name getAllItemTypeMaster
   * @returns Promise
   * @description fetch all GetAllItemTypeMaster
   */

  getAllItemTypeMaster() {
    return this.customAxios.get(`ItemType/GetAllItemTypeMaster`);
  }

  /**
   * @name getAllCustomers
   * @returns Promise
   * @description fetch all Customers Types
   */

  getAllCustomers() {
    return this.customAxios.get(`Customer/GetAllCustomers`);
  }

  /**
   * @name getAllInvoiceTypes
   * @returns Promise
   * @description fetch all Invoice Types
   */

  getAllInvoiceTypes() {
    return this.customAxios.get(`InvoiceType/GetAllInvoiceTypes`);
  }

  /**
   * @name getAllCustomerContactByCustomerId
   * @param {number} customerId
   * @returns Promise
   * @description fetch all item
   */
  getAllCustomerContactByCustomerId(customerId) {
    return this.customAxios.get(
      `CustomerContact/GetAllCustomerContactByCustomerId?customerContactId=` +
        customerId
    );
  }

  /**
   * @name getAllItemCatalogs
   * @param {number} companyId
   * @returns Promise
   * @description fetch all item
   */
  getAllItemCatalogs(companyId: number) {
    return this.customAxios.get(`ItemCatalog/GetAllItemCatalogs?companyId=${companyId}`);
  }

  /**
   * @name getAllUoms
   * @returns Promise
   * @description fetch all item
   */
  getAllUoms() {
    return this.customAxios.get(`UOM/GetAllUoms`);
  }
  /**
   * @name getAllMaterials
   * @returns Promise
   * @description fetch all item
   */
  getAllMaterials() {
    return this.customAxios.get(`Material/GetAllMaterials`);
  }

  /**
   * @name getAllFocals
   * @returns Promise
   * @description fetch all item
   */
  getAllFocals() {
    return this.customAxios.get(`Focal/GetAllFocals`);
  }

  /**
   * @name getAllIndexByMaterialId
   * @returns Promise
   * @description fetch all Index by material id
   */
  getAllIndexByMaterialId(materialId: number) {
    return this.customAxios.get(`Index/GetIndexesByMaterialId?materialId=${materialId}`);
  }
  /**
   * @name getFocal
   * @returns Promise
   * @description fetch all item
   */
  getFocal() {
    return this.customAxios.get(
      `ItemTypeFocalAssociation/GetAllItemTypeFocalAssociations`
    );
  }
  /**
   * @name getAllDesignTechs
   * @returns Promise
   * @description fetch all item
   */

  getAllDesignTechs() {
    return this.customAxios.get(`DesignTech/GetAllDesignTechs`);
  }

  /**
   * @name getBrand
   * @returns Promise
   * @description fetch all item
   */
  getBrand() {
    return this.customAxios.get(`Brand/GetAllBrands`);
  }

  /**
   * @name getAllBrandMasters
   * @returns Promise
   * @description fetch all BrandMaster item
   */
  getAllBrandMasters() {
    return this.customAxios.get(`BrandMaster/GetAllBrandMasters`);
  }

  /**
   * @name getAllFilters
   * @returns Promise
   * @description fetch all item
   */

  getAllFilters() {
    return this.customAxios.get(`Filter/GetAllFilters`);
  }

  /**
   * @name getAllCoatingBrands
   * @returns Promise
   * @description fetch all item
   */

  getAllCoatingBrands() {
    return this.customAxios.get(`CoatingBrand/GetAllCoatingBrands`);
  }

  /**
   * @name getAllLensShape
   * @returns Promise
   * @description fetch all item
   */

  getAllLensShape() {
    return this.customAxios.get(`LensShape/GetAllLensShapes`);
  }

  /**
   * @name getAllLensShape
   * @returns Promise
   * @description fetch all item
   */

  getAllFrameCondition() {
    return this.customAxios.get(`FrameCondition/GetAllFrameConditions`);
  }

  /**
   * @name getAllFrameType
   * @returns Promise
   * @description fetch all item
   */

  getAllFrameType() {
    return this.customAxios.get(`FrameType/GetAllFrameTypes`);
  }

  /**
   * @name getAllFrameType
   * @returns Promise
   * @description fetch all item
   */

  getAllModel() {
    return this.customAxios.get(`Model/GetAllModels`);
  }

  /**
   * @name getAllColors
   * @returns Promise
   * @description fetch all item
   */

  getAllColors() {
    return this.customAxios.get(`Color/GetAllColors`);
  }

  /**
   * @name getAllColorMasters
   * @returns Promise
   * @description fetch all ColorMaster item
   */

  getAllColorMasters() {
    return this.customAxios.get(`ColorMaster/GetAllColorMasters`);
  }

  /**
   * @name getAllCompanyBranches
   * @returns Promise
   * @description fetch all item
   */

  getAllCompanyBranches(isPlant: any) {
    // return this.customAxios.get(`CompanyBranch/GetAllCompanyBranches`);
    return this.customAxios.get(
      `CompanyBranch/GetAllCompanyBranchByIsPlant?isPlant=` + isPlant
    );
  }
  /**
   * @name getAllCompanyBranchesWithOutIsplant
   * @returns Promise
   * @description fetch all item
   */

  getAllCompanyBranchesWithOutIsplant() {
    return this.customAxios.get(`CompanyBranch/GetAllCompanyBranches`);
  }

  /**
   * @name getSPH
   * @param {number} range1
   * @param {number} range2
   * @returns sph range
   * @memberof salesService
   */
  getSPH(range1: number, range2: number) {
    return this.customAxios.get(`ItemCatalog/GetSPH?range1=${range1}&range2=${range2}`);
  }

  /**
   * @name getStockSPH
   * @params {number} itemCatalogGroupId
   * @returns Promise
   * @description fetch all item
   */

  getStockSPH(itemCatalogGroupId: any) {
    return this.customAxios.get(
      `ItemCatalog/GetStockSPH?itemCatalogGroupId=` + itemCatalogGroupId
    );
  }
  /**
   * @name getStockCYL
   * @param {number} itemCatalogGroupId
   * @param {number} sph
   * @returns sph range
   * @memberof salesService
   */
  getStockCYL(itemCatalogGroupId: number, sph: number) {
    return this.customAxios.get(
      `ItemCatalog/GetStockCYL?itemCatalogGroupId=${itemCatalogGroupId}&sph=${sph}`
    );
  }

  /**
   * @name getStockADD
   * @param {number} itemCatalogGroupId
   * @param {number} sph
   * @returns sph range
   * @memberof salesService
   */
  getStockADD(itemCatalogGroupId: number, sph: number) {
    return this.customAxios.get(
      `ItemCatalog/GetStockADD?itemCatalogGroupId=${itemCatalogGroupId}&sph=${sph}`
    );
  }

  /**
   * @name getCYL
   * @param {number} range1
   * @param {number} range2
   * @returns cyl range
   * @memberof salesService
   */
  getCYL(range1: number, range2: number) {
    return this.customAxios.get(`ItemCatalog/GetCYL?range1=${range1}&range2=${range2}`);
  }

  /**
   * @name getADDF
   * @param {number} range1
   * @param {number} range2
   * @returns cyl range
   * @memberof salesService
   */
  getADDF(range1: number, range2: number) {
    return this.customAxios.get(`ItemCatalog/GetADDF?range1=${range1}&range2=${range2}`);
  }
  /**
   * @name getAllHCoating
   * @returns Promise
   * @description fetch all item
   */

  getAllHCoating() {
    return this.customAxios.get(`HCoating/GetAllHcoatings`);
  }

  /**
   * @name getAllHCoating
   * @returns Promise
   * @description fetch all item
   */

  getAllCoating() {
    return this.customAxios.get(`Coating/GetAllCoatings`);
  }

  /**
   * @name getAllMirrors
   * @returns Promise
   * @description fetch all item
   */

  getAllMirrors() {
    return this.customAxios.get(`Mirror/GetAllMirrors`);
  }
  /**
   * @name getAllFittingTypes
   * @returns Promise
   * @description fetch all FittingType
   */
  getAllFittingTypes() {
    return this.customAxios.get(`FittingType/GetAllFittingTypes`);
  }

  /**
   * @name getAllMirrors
   * @returns Promise
   * @description fetch all item
   */

  getAllTints() {
    return this.customAxios.get(`Tint/GetAllTints`);
  }

  /**
   * @name addSalesOrder
   * @method POST
   * @return Promise
   */
  addSalesOrder(payload: any, salesOrderId?: number) {
    if (salesOrderId) {
      return this.customAxios.post("SalesOrder/UpdateSalesOrder", payload);
    } else {
      return this.customAxios.post("SalesOrder/AddSalesOrder", payload);
    }
  }

  /**
   * @name getAllSalesOrders
   * @returns Promise
   * @description fetch all item
   */

  getAllSalesOrders(companyBranchId: any) {
    return this.customAxios.get(
      `SalesOrder/GetAllSalesOrders?createdByBranchId=` + companyBranchId
    );
  }

  /**
   * @name getAllSalesOrders
   * @param salesOrderId
   * @returns Promise
   * @description fetch all item
   */

  deleteSalesOrder(salesOrderId) {
    return this.customAxios.get(`SalesOrder/DeleteSalesOrder?id=${salesOrderId}&updateUserId=${JSON.parse(localStorage.getItem("userData")).id}`);
  }

  /**
   * @name getAllSalesOrderBySalesOrderId
   * @param {number} salesOrderId
   * @returns Promise
   * @description fetch all item
   */
  getAllSalesOrderBySalesOrderId(salesOrderId) {
    return this.customAxios.get(`SalesOrder/GetSalesOrderById?id=` + salesOrderId);
  }

  /**
   * @name addSalesOrder
   * @method POST
   * @return Promise
   */
  addSalesOrderLens(payload: any, salesOrderLenId?: number) {
    if (salesOrderLenId) {
      return this.customAxios.post("SalesOrder/UpdateSalesOrderStockLens", payload);
    } else {
      return this.customAxios.post("SalesOrder/AddSalesOrderStockLens", payload);
    }
  }

  /**
   * @name getAllSalesOrderBySalesOrderId
   * @param {number} salesOrderId
   * @returns Promise
   * @description fetch all item
   */
  getAllSalesOrderBySalesOrderStockLensId(salesOrderId) {
    return this.customAxios.get(
      `SalesOrder/GetSalesOrderStockLensById?id=` + salesOrderId
    );
  }

  /**
   * @name getSalesOrderStockIssueDetailBySalesOrderId
   * @param {number} salesOrderId
   * @returns Promise
   * @description fetch all item
   */
  getSalesOrderStockIssueDetailBySalesOrderId(salesOrderId: number) {
    return this.customAxios.get(
      `SalesOrderStockIssue/GetSalesOrderStockIssueDetailBySalesOrderId?salesOrderId=` +
        salesOrderId
    );
  }

  /**
   * @name getIStockIssueForDispatchCounter
   * @param {number} salesOrderId
   * @returns Promise
   * @description fetch all item
   */
  getIStockIssueForDispatchCounter(salesOrderId: number) {
    return this.customAxios.get(
      `SalesOrderStockIssue/GetIStockIssueForDispatchCounter?salesOrderId=` +
        salesOrderId
    );
  }

  /**
   * @name generateSalesOrderReport
   * @param {number} salesOrderId
   * @returns Promise
   * @description Generate Sale order Report
   */
  generateSalesOrderReport(salesOrderId: number, isUpdate: boolean) {
    return this.customAxios.get(
      `Report/GenerateSalesOrderReport?salesOrderId=` +
        salesOrderId +
        "&isUpdate=" +
        isUpdate
    );
  }
  /**
   * @name generateJobOrderStockReport
   * @param {number} salesOrderId
   * @returns Promise
   * @description Generate Sale order Report
   */
  generateJobOrderStockReport(salesOrderId: number, isUpdate: boolean) {
    return this.customAxios.get(
      `Report/GenerateJobOrderStockReport?salesOrderId=` +
        salesOrderId +
        "&isUpdate=" +
        isUpdate
    );
  }

  /**
   * @name getAllCutUncuts
   * @returns Promise
   * @description fetch record
   */
  getAllCutUncuts() {
    return this.customAxios.get(`CutUncut/GetAllCutUncuts`);
  }
  /**
   * @name getAllOtherServies
   * @returns Promise
   * @description fetch record
   */
  getAllOtherServies() {
    return this.customAxios.get(`OtherService/GetAllOtherServies`);
  }
  /**
   * @name getAllEngraves
   * @returns Promise
   * @description fetch record
   */
  getAllEngraves() {
    return this.customAxios.get(`Engrave/GetAllEngraves`);
  }

  /**
   * @name getAllSOAttributes
   * @params {number} brandMasterId
   * @params {number} subBrandMasterId
   * @returns Promise
   * @description fetch record
   */
  getAllSOAttributes(brandMasterId: number, subBrandMasterId: number) {
    return this.customAxios.get(
      `SOAttribute/GetSOAttributesByBrandAndSubBrandId?brandMasterId=${brandMasterId}&subBrandMasterId=${subBrandMasterId}`
    );
  }

  /**
   * @name getVendorItemByBarcode
   * @params {number} barcode
   * @returns Promise
   * @description fetch record
   */
  // getVendorItemByBarcode(barcode: number,) {
  //   return this.customAxios.get(`VendorItemCatalog/GetVendorItemByBarCode?barCodeId=${barcode}`);
  // }
  getVendorItemByBarcode(
    barCode: any,
    itemCatalogId: any,
    lensSideId: any,
    baseCx: any,
    isUserSupervisor: any
  ) {
    return this.customAxios.get(
      `VendorItemCatalog/GetVendorItemByBarCode?barCodeId=${barCode}&itemCatalogId=${itemCatalogId}&lensSideId=${lensSideId}&baseCx=${baseCx}&isUserSupervisor=${isUserSupervisor}`
    );
  }

  /**
   * @name getVendorItemByBarcode
   * @params {number} barcode
   * @returns Promise
   * @description fetch record
   */
  getVendorItem(barcode: number, companyBranchId: any) {
    return this.customAxios.get(
      `VendorItemCatalog/GetCatalogByBarcode?barCodeId=${barcode}&companyBranchId=${companyBranchId}`
    );
  }

  /**
   * @name getAlternativeByBarCode
   * @params {number} barcode, itemCatalogId
   * @returns Promise
   * @description fetch record
   */
  getAlternativeByBarCode(barcode: any, itemCatalogId: any) {
    return this.customAxios.get(
      `CatalogGroup/GetAlternativeByBarCode?barCode=${barcode}&itemCatalogId=${itemCatalogId}`
    );
  }
  /**
   * @name getStockIssueItemCatalogByBarCode
   * @param {number | string} barCodeId
   * @param {number} itemCatalogId
   * @param {number} refItemCatalogId
   * @returns Promise
   * @description fetch record
   */
  getStockIssueItemCatalogByBarCode(
    barCodeId: any,
    itemCatalogId?: number,
    refItemCatalogId?: number
  ) {
    return this.customAxios.get(
      `VendorItemCatalog/GetStockIssueItemCatalogByBarCode?barCodeId=${barCodeId}&itemCatalogId=${
        itemCatalogId ? itemCatalogId : 0
      }&refItemCatalogId=${refItemCatalogId ? refItemCatalogId : 0}`
    );
  }
  /**
   * @name getVendorItemByBarcodeAndItemCatalogId
   * @params {number} barcode itemCatalogId
   * @returns Promise
   * @description fetch record
   */
  getVendorItemByBarcodeAndItemCatalogId(
    barcode: number,
    itemCatalogId: number
  ) {
    return this.customAxios.get(
      `VendorItemCatalog/GetVendorItemByBarCode?barCodeId=${barcode}&?itemCatalogId=${itemCatalogId}`
    );
  }

  /**
   * @name getAllFromCompanies
   * @returns Promise
   * @description fetch all item
   */

  getAllBranchRleation() {
    return this.customAxios.get(`BranchRelation/GetAllBranchRelation`);
  }

  /**
   * @name getAllBranchRleationFromCompanyBranchId
   * @param {number} fromCompanyBranchId
   * @returns Promise
   * @description fetch all item
   */

  getAllBranchRleationFromCompanyBranchId(fromCompanyBranchId: number) {
    return this.customAxios.get(
      `BranchRelation/GetBranchRelationsByFromCompanyBranchId?fromCompanyBranchId=${fromCompanyBranchId}`
    );
  }

  /**
   * @name addOrderRedirect
   * @method POST
   * @return Promise
   */
  addOrderRedirect(payload: any, salesOrderTransferId?: number) {
    if (salesOrderTransferId) {
      return this.customAxios.post("SalesOrderTransfer/UpdateSalesOrderTransfer", payload);
    } else {
      return this.customAxios.post("SalesOrderTransfer/AddSalesOrderTransfer", payload);
    }
  }

  /**
   * @name getSalesOrderTransferBySalesOrderTransferId
   * @params {number} SalesOrderTransferId
   * @returns Promise
   * @description fetch SalesOrderTransfer
   */
  getSalesOrderTransferBySalesOrderTransferId(SalesOrderTransferId: number) {
    return this.customAxios.get(
      `SalesOrderTransfer/GetSalesOrderTransferBySalesOrderTransferId?SalesOrderTransferId=${SalesOrderTransferId}`
    );
  }

  /**
   * @name getAllFromCompanies
   * @returns Promise
   * @description fetch all item
   */

  getAllSalesOrderTransfer(companyBranchId: number) {
    return this.customAxios.get(
      `SalesOrderTransfer/GetAllSalesOrderTransfer?companyBranchId=${companyBranchId}`
    );
  }

  /**
   * @name getAllSalesOrders
   * @param salesOrderId
   * @returns Promise
   * @description fetch all item
   */

  deleteSalesOrderTransfer(salesOrderTransferId: number) {
    return this.customAxios.get(
      `SalesOrderTransfer/DeleteSalesOrderTransfer?SalesOrderTransferId=${salesOrderTransferId}`
    );
  }

  /**
   * @name GetAllSalesOrderStockIssues
   * @param
   * @returns Promise
   * @description fetch all item
   */
  GetAllSalesOrderStockIssues(
    companyBranchId: number,
    salesOrderId?: number,
    fromDate?: any,
    toDate?: any,
    includeDateFilter?: boolean
  ) {
    return this.customAxios.get(
      `SalesOrderStockIssue/GetAllSalesOrderStockIssues?companyBranchId=${companyBranchId}&salesOrderId=${salesOrderId}&fromDate=${fromDate}&toDate=${toDate}&includeDateFilter=${includeDateFilter}`
    );
  }

  /**
   * @name getAllRxReasonsByProcessId
   * @returns fetch all reasons according to process id
   */
  getAllRxReasonsByProcessId(processId: number) {
    return this.customAxios.get(
      "RxReason/GetAllRxReasonsByProcessId?processId=" + processId
    );
  }

  /**
   * @name addSalesOrderStockIssue
   * @param payload
   * @return void
   */
  addSalesOrderStockIssue(payload: any, salesOrderStockIssueId?: number) {
    if (salesOrderStockIssueId) {
      return this.customAxios.post(
        "SalesOrderStockIssue/UpdateSalesOrderStockIssue",
        payload
      );
    } else {
      return this.customAxios.post(
        "SalesOrderStockIssue/AddSalesOrderStockIssue",
        payload
      );
    }
  }

  /**
   * @name salesOrderStockIssueId
   * @param salesOrderStockIssueId
   * @returns Promise
   * @description deletes item
   */
  deleteStockIssue(salesOrderStockIssueId: number) {
    return this.customAxios.get(
      `SalesOrderStockIssue/DeleteSalesOrderStockIssue?id=${salesOrderStockIssueId}`
    );
  }

  /**
   * @name getAllSalesOrderStockIssuesById
   * @param stockIssueId
   * @returns Promise
   * @description fetch item
   */
  getAllSalesOrderStockIssuesById(stockIssueId: number) {
    return this.customAxios.get(
      `SalesOrderStockIssue/GetSalesOrderStockIssueById?id=${stockIssueId}`
    );
  }

  /**
   * @name getSalesOrderStockIssueDetailByStockIssueId
   * @param stockIssueId
   * @returns Promise
   * @description fetch item
   */
  getSalesOrderStockIssueDetailByStockIssueId(stockIssueId: number) {
    return this.customAxios.get(
      `SalesOrderStockIssue/GetSalesOrderStockIssueDetailByStockIssueId?salesOrderStockIssueId=${stockIssueId}`
    );
  }
  /**
   * @name generateSOStockIssueReport
   * @param salesOrderStockIssueId
   * @returns Promise
   * @description generate report
   */
  generateSOStockIssueReport(salesOrderStockIssueId: number) {
    return this.customAxios.get(
      `Report/GenerateSOStockIssueReport?salesOrderStockIssueNo=${salesOrderStockIssueId}`
    );
  }

  /**
   * @name generateStockIssueReport
   * @param stockIssueNo
   * @returns Promise
   * @description generate report
   */
  generateStockIssueReport(stockIssueNo: number) {
    return this.customAxios.get(
      `Report/GenerateStockIssueReport?stockIssueNo=${stockIssueNo}`
    );
  }

  /**
   * @name getAllDispatchList
   * @param
   * @returns Promise
   * @description fetch item
   */
  getAllDispatchList(companyBranchId: number) {
    return this.customAxios.get(
      `DispatchList/GetAllDispatchList?companyBranchId=${companyBranchId}`
    );
  }

  /**
   * @name getAllAcknowledgeDispatchList
   * @param
   * @returns Promise
   * @description fetch item
   */
  getAllAcknowledgeDispatchList(companyBranchId: number) {
    return this.customAxios.get(
      `DispatchList/GetAllAcknowledgeDispatchList?companyBranchId=${companyBranchId}`
    );
  }

  /**
   * @name deleteDispatchOrder
   * @param dispatchListId
   * @returns Promise
   * @description deletes item
   */
  deleteDispatchOrder(dispatchListId: number) {
    return this.customAxios.get(
      `DispatchList/DeleteDispatchList?dispatchListId=${dispatchListId}`
    );
  }

  /**
   * @name getAllDriversList
   * @param
   * @returns Promise
   * @description fetch item
   */
  getAllDriversList() {
    return this.customAxios.get(`Driver/GetAllDrivers`);
  }

  /**
   * @name getAllDriversByCompanyBranchId
   * @param
   * @returns Promise
   * @description fetch item
   */
  getAllDriversByCompanyBranchId(companyBranchId: number) {
    return this.customAxios.get(
      `Driver/GetAllDriversByBranchId?companyBranchId=${companyBranchId}`
    );
  }

  /**
   * @name getAllProductionOutList
   * @param companyBranchId
   * @returns Promise
   * @description Production Out List
   */
  getAllProductionOutList(companyBranchId: number) {
    return this.customAxios.get(
      `ProductionOut/GetProductionOut?createByBranchId=${companyBranchId}`
    );
    // return this.customAxios.get(`ProductionOut/GetAllProductionOut`);
  }

  /**
   * @name getDispatchListSalesIssuance_AcknowledgedByBranch
   * @param companyBranchId
   * @returns Promise
   * @description Production Out List
   */
  getDispatchListSalesIssuance_AcknowledgedByBranch(companyBranchId: number) {
    return this.customAxios.get(
      `DispatchList/GetDispatchListSalesIssuance_AcknowledgedByBranch?companyBranchId=${companyBranchId}`
    );
  }

  /**
   * @name addDispatchOrder
   * @param payload, dispatchListId
   * @return void
   */
  addDispatchOrder(payload: any, dispatchListId?: number) {
    if (dispatchListId) {
      return this.customAxios.post("DispatchList/UpdateDispatchList", payload);
    } else {
      return this.customAxios.post("DispatchList/AddDispatchList", payload);
    }
  }

  /**
   * @name getAllDispatchListById
   * @param dispatchListId
   * @returns Promise
   * @description fetch item
   */
  getAllDispatchListById(dispatchListId: number) {
    return this.customAxios.get(
      `DispatchList/GetByDispatchListId?dispatchListId=${dispatchListId}`
    );
  }

  /**
   * @name getAllCustomerCompanyBranchId
   * @param {number} companyBranchId
   * @returns Promise
   * @description fetch Customers
   */
  getAllCustomerCompanyBranchId(companyBranchId: number) {
    return this.customAxios.get(
      `Customer/GetAllCustomerCompanyBranchId?companyBranchId=${companyBranchId}`
    );
  }

  /**
   * @name getCustomerCompanyBranchId
   * @param {number} userId
   * @param {number} companyBranchId
   * @returns Promise
   * @description fetch Customers
   */
   getCustomerCompanyBranchId(companyBranchId: number, userId: number) {
    return this.customAxios.get(
      `Customer/GetCustomerCompanyBranchId?companyBranchId=${companyBranchId ? companyBranchId : 0}&userId=${userId ? userId : 0}`
    );
  }

  /**
   * @name getCustomerCompanyBranchId
   * @param {number} userId
   * @param {number} customerId
   * @returns Promise
   * @description fetch Customers
   */
   getAllCompanyBranchByCustomerId(customerId: number, userId: number) {
    return this.customAxios.get(
      `Customer/GetAllCompanyBranchByCustomerId?customerId=${customerId ? customerId : 0}&userId=${userId ? userId : 0}`
    );
  }


  /**
   * @name getColorByColorMasterIdAndFilterBrandId
   * @param {event}  filterBrandId
   * @param {event}  colorMasterId
   * @return colorsList
   * @description fetch data by id
   *
   */
  getColorByColorMasterIdAndFilterBrandId(filterBrandId) {
    return this.customAxios.get(
      "Color/GetColorsByColorMasterIdAndFilterBrandId?filterBrandId=" +
        filterBrandId
    );
  }

  /**
   * @name getTintColor
   * @param {event}  object
   * @param {number} brandMasterId
   * @param {number} materialId
   * @return coatingBrands
   * @description fetch data by id
   *
   */
  getTintColor(brandMasterId: number, materialId: number) {
    return this.customAxios.get(
      "Color/GetTintColor?brandMasterId=" +
        brandMasterId +
        "&materialId=" +
        materialId
    );
  }

  /**
   * @name GetCoatingBrandByBrandMasterIdAndMaterialId
   * @param {event}  object
   * @param {number} brandMasterId
   * @param {number} materialId
   * @return coatingBrands
   * @description fetch data by id
   *
   */
  getCoatingBrandByBrandMasterIdAndMaterialId(
    brandMasterId,
    materialId,
    isHC?: boolean,
    customerId?:  number
  ) {
    return this.customAxios.get(
      "CoatingBrand/GetCoatingBrandsByBrandMasterIdAndMaterialId?brandMasterId=" +
        brandMasterId +
        "&materialId=" +
        materialId +
        "&isHC=" +
        isHC + "&customerId=" + customerId
    );
  }

  /**
   * @name getHcBrandByBrandMasterIdAndMaterialId
   * @param {event}  object
   * @param {number} brandMasterId
   * @param {number} materialId
   * @param {number} isHC
   * @return coatingBrands
   * @description fetch data by id
   *
   */
  getHcBrandByBrandMasterIdAndMaterialId(
    brandMasterId: number,
    materialId: number,
    isHc: boolean,
    customerId?: boolean
  ) {
    return this.customAxios.get(
      "CoatingBrand/GetCoatingBrandsByBrandMasterIdAndMaterialId?brandMasterId=" +
        brandMasterId +
        "&materialId=" +
        materialId +
        "&isHc=" +
        isHc + "&customerId=" + customerId
    );
  }

  /**
   * @name getAllInvoice
   * @param payload
   * @returns Promise
   * @description fetch item
   */
  getAllInvoice(payload: any) {
    return this.customAxios.get(
      `Invoice/GetAllInvoices?invoiceId=${payload.invoiceId}&companyBranchId=${payload.companyBranchId}&customerId=${payload.customerId}&customerBranchId=${payload.customerBranchId}&FromDate=${payload.fromDate}&ToDate=${payload.toDate}&includeDateFilter=${payload.includeDateFilter}`
    );
  }

  /**
   * @name deleteInvoice
   * @param invoiceId
   * @returns Promise
   * @description deletes item
   */
  deleteInvoice(invoiceId: number) {
    return this.customAxios.get(`Invoice/DeleteInvoice?id=${invoiceId}`);
  }

  /**
   * @name getAllDeliveryModes
   * @param
   * @returns Promise
   * @description fetch item
   */
  getAllDeliveryModes() {
    return this.customAxios.get(`DeliveryMode/GetAllDeliveryModes`);
  }

  /**
   * @name getAllCourierNames
   * @param
   * @returns Promise
   * @description fetch item
   */
  getAllCourierNames() {
    return this.customAxios.get(`Courier/GetAllCouries`);
  }

  /**
   * @name getAllCustomerContactByCustomerBranchId
   * @param customerBranchId
   * @returns Promise
   * @description CustomerContact item
   */
  getAllCustomerContactByCustomerBranchId(customerBranchId: number) {
    return this.customAxios.get(
      `CustomerContact/GetAllCustomerContactByCustomerBranchId?customerBranchId=${customerBranchId}`
    );
  }
  /**
   * @name getAllCompanyBranchesForDispatch
   * @returns Promise
   * @description fetch all item
   */

  getAllCompanyBranchesForDispatch() {
    return this.customAxios.get(`DispatchList/GetAllCompanyBranchForDispatch`);
  }

  /**
   * @name getAllInvoiceDetailsByCusomerId
   * @param {event}  object
   * @param {number} customerBranchId
   * @param {number} fromDate
   * @param {number} toDate
   * @return coatingBrands
   * @description fetch data by id
   *
   */
  getAllInvoiceDetailsByCusomerId(
    customerBranchId: number,
    fromDate: string,
    toDate: string
  ) {
    return this.customAxios.get(
      "InvoiceDetail/GetSalesOrderDetailByCustomerBranchIdAndDate?customerBranchId=" +
        customerBranchId +
        "&fromDate=" +
        moment(fromDate).format("YYYY-MM-DD") +
        "&toDate=" +
        moment(toDate).format("YYYY-MM-DD")
    );
  }

  /**
   * @name getAllInvoiceDetailsByCusomerId
   * @param {event}  object
   * @param {number} customerBranchId
   * @param {number} fromDate
   * @param {number} toDate
   * @return coatingBrands
   * @description fetch data by id
   *
   */
  getAllInvoiceDetailsByCusomerId2(
    customerBranchId: number,
    fromDate: string,
    toDate: string
  ) {
    return this.customAxios.post("InvoiceDetail/GetInvoiceLineItemes", {
      customerBranchId: customerBranchId,
      fromDate: null,
      toDate: null,
    });
  }

  /**
   * @name AddInvoice
   * @param payload, invoiceId
   * @return void
   */
  addInvoice(payload: any, invoiceId?: number) {
    if (invoiceId) {
      return this.customAxios.post("Invoice/UpdateInvoice", payload);
    } else {
      return this.customAxios.post("Invoice/AddInvoice", payload);
    }
  }

  /**
   * @name getInvoiceById
   * @param invoiceId
   * @returns Promise
   * @description IInvoice item
   */
  getInvoiceById(invoiceId: number) {
    return this.customAxios.get(`Invoice/GetInvoiceById?id=${invoiceId}`);
  }

  /**
   * @name GenerateSalesInvoiceReport
   * @param invoiceId
   * @returns Promise
   * @description generate report
   */
  generateSalesInvoiceReport(invoiceId: number) {
    return this.customAxios.get(
      `Report/GenerateSalesInvoiceReport?invoiceId=${invoiceId}`
    );
  }

  /**
   * @name getDispatchListByBranch
   * @param
   * @returns Promise
   * @description disatch list by branch
   */
  getDispatchListByBranch() {
    let selectedBranch = JSON.parse(
      localStorage.getItem("selectedCustomerBranch")
    ).companyBranchId;
    return this.customAxios.get(
      `DispatchList/GetDispatchList_AcknowledgedByBranch?companyBranchId=${selectedBranch}`
    );
  }

  /**
   * @name getCurrencyByCountryId
   * @param countryId
   * @returns Promise
   * @description Currency item
   */
  getCurrencyByCountryId(countryId: number) {
    return this.customAxios.get(`Currency/GetCurrencyByCountryId?countryId=${countryId}`);
  }

  /**
   * @name getFnPrice
   * @param companyId
   * @returns Promise
   * @description Currency item
   */
  getFnPrice(
    companyId: number,
    customerId: number,
    itemCatalogGroupId: number,
    focalId: number,
    brandMasterId: number,
    sph: any,
    cyl: any,
    add: any,
    isBarcodeSingleSide: boolean,
    companyBranchId: number
  ) {
    return this.customAxios.get(
      `Pricing/GetFnPrice?companyId=${companyId}&customerId=${customerId}&itemCatalogGroupId=${itemCatalogGroupId}&focalId=${focalId}&brandMasterId=${brandMasterId}&sph=${sph}&cyl=${cyl}&add=${add}&isBarcodeSingleSide=${isBarcodeSingleSide}&companyBranchId=${companyBranchId}`
    );
  }

  /**
   * @name getRxPrice
   * @param companyId
   * @returns Promise
   * @description Currency item
   */
  getRxPrice(
    companyId: number,
    customerBranchId: number,
    itemCatalogGroupId: number,
    focalId: number,
    brandMasterId: number,
    sph: any,
    cyl: any,
    add: any,
    isBarcodeSingleSide: boolean,
    companyBranchId: number,
    priceGroupMasterId: number,
    diameter?: any,
    cityId?: number,
    coatingBrandId?: number,
    mirrorId?: number,
    tintId?: number
  ) {
    return this.customAxios.get(
      `Pricing/GetRxPrice?companyId=${companyId}&customerBranchId=${customerBranchId}&itemCatalogGroupId=${itemCatalogGroupId}&focalId=${focalId}&brandMasterId=${brandMasterId}&sph=${sph}&cyl=${cyl}&add=${add}&isBarcodeSingleSide=${isBarcodeSingleSide}&companyBranchId=${companyBranchId}&priceGroupMasterId=${priceGroupMasterId}&diameter=${diameter}&cityId=${cityId}&coatingBrandId=${
        coatingBrandId ? coatingBrandId : 0
      }&mirrorId=${mirrorId ? mirrorId : 0}&tintId=${tintId ? tintId : 0}`
    );
  }

  /**
   * @name getBarcodesList
   * @param itemCatalogId, focalId, sph, cyl, add
   * @returns Promise
   * @description Currency item
   */
  getBarcodesList(
    itemCatalogId: number,
    focalId: number,
    sph: number,
    cyl: number,
    add: number
  ) {
    return this.customAxios.get(
      `VendorItemCatalog/GetBarcodeList?itemCatalogId=${itemCatalogId}&focalId=${focalId}&sph=${sph}&cyl=${cyl}&add=${add}`
    );
  }

  /**
   * @name getBarcodesList
   * @param itemCatalogId, focalId, sph, cyl, add
   * @returns Promise
   * @description Currency item
   */
  getCatalogListByItemCatalogId(itemCatalogId: number) {
    return this.customAxios.get(
      `CatalogGroup/GetAllCatalogGroupDetailByItemCatalgId?itemCatalogId=${itemCatalogId}`
    );
  }

  /**
   * @name getAllLensSides
   * @returns Promise
   * @description all lense
   */
  getAllLensSides() {
    return this.customAxios.get(`LensSide/GetAllLensSides`);
  }

  /**
   * @name deleteItemCatalogRange
   * @param {number} itemCatalogRangeId
   * @returns Promise
   * @description remove range
   */
  deleteItemCatalogRange(itemCatalogRangeId: number) {
    return this.customAxios.get(
      "ItemCatalogRange/DeleteItemCatalogRange?id=" + itemCatalogRangeId
    );
  }

  /**
   * @name deleteSOStockIssueDetailIList
   * @param {number} salesOrderStockIssueDetailId
   * @returns Promise
   * @description remove range
   */
  deleteSOStockIssueDetailIList(soStockIssueDetailIListId: number) {
    return this.customAxios.get(
      "SalesOrderStockIssueDetail/DeleteSOStockIssueDetailIList?id=" +
        soStockIssueDetailIListId
    );
  }

  /**
   * @name readyForDispatch
   * @param {number}  salesOrderId
   * @return void
   */
  readyForDispatch(salesOrderId: number) {
    return this.customAxios.post(
      "DispatchCounter/ReadyForDispatch?salesOrderId=" + salesOrderId,
      {}
    );
  }

  /**
   * @name deleteDispatchedSalesOrder
   * @param {number} salesOrderId
   * @returns Promise
   * @description remove Dispatched Sales Order
   */
  deleteDispatchedSalesOrder(salesOrderId: number) {
    return this.customAxios.get(
      "SalesOrderStockIssue/DeleteAcknowledgedForDispatch?salesOrderId=" +
        salesOrderId
    );
  }

  /**
   * @name getExchangeRateByCountryId
   * @param countryId
   * @returns Promise
   * @description exchange rate by country id
   */
  getExchangeRateByCountryId(countryId: number) {
    return this.customAxios.get(
      `ExchangeRate/GetExchangeRateByCountryId?countryId=${countryId}`
    );
  }

  /**
   *@name getCatalogComboList
   * @param {number} itemCatalogId
   * @param {number} companyId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getCatalogComboList(
    itemCatalogId: number,
    companyId: number,
    customerId: number,
    priceGroupMasterId: number
  ) {
    return this.customAxios.get(
      `ComboPricing/GetCatalogComboList?itemCatalogId=${itemCatalogId}&companyId=${companyId}&customerId=${customerId}&priceGroupMasterId=${priceGroupMasterId}`
    );
  }

  /**
   *@name getLensPrice
   * @param {number} itemCatalogId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getLensPrice(itemCatalogId: number, customerId: number) {
    return this.customAxios.get(
      `ServicePricing/GetLensPrice?itemCatalogId=${itemCatalogId}&customerId=${customerId}`
    );
  }

  /**
   *@name getCoatingPrice
   * @param {number} coatingBrandId
   * @param {number} brandMasterId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getCoatingPrice(
    coatingBrandId: number,
    brandMasterId: number,
    customerId: number
  ) {
    return this.customAxios.get(
      `ServicePricing/GetCoatingPrice?coatingBrandId=${coatingBrandId}&brandMasterId=${brandMasterId}&customerId=${customerId}&companyId=${JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId}`
    );
  }

  /**
   *@name getTintPrice
   * @param {number} tintId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getTintPrice(tintId: number, customerId: number) {
    return this.customAxios.get(
      `ServicePricing/GetTintPrice?tintId=${tintId}&customerId=${customerId}&companyId=${JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId}`
    );
  }

  /**
   *@name getPrismPrice
   * @param {number} prismValue
   * @param {number} customerId
   * @param {number} brandMasterId
   * @param {number} materialId
   * @returns
   * @memberof SalesService
   */
  getPrismPrice(
    prismValue: number,
    customerId: number,
    brandMasterId?: number,
    materialId?: number
  ) {
    return this.customAxios.get(
      `ServicePricing/GetPrismPrice?prismValue=${prismValue}&customerId=${customerId}&brandMasterId=${
        brandMasterId ? brandMasterId : 0
      }&materialId=${materialId ? materialId : 0}&companyId=${JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId}`
    );
  }

  /**
   * @name getEdgingPrice
   *
   * @param {number} brandMasterId
   * @param {number} customerId
   * @param {number} indexId
   * @param {number} materialId
   * @param {nmumber} frameId
   * @returns
   * @memberof SalesService
   */
  getEdgingPrice(
    brandMasterId: number,
    customerBranchId: number,
    indexId: number,
    materialId: number,
    frameId: number,
    itemTypeMasterId: number,
    isOurLens?: boolean
  ) {
    return this.customAxios.get(
      `ServicePricing/GetEdgingPrice?brandMasterId=${brandMasterId}&customerBranchId=${customerBranchId}&indexId=${indexId}&materialId=${materialId}&frameId=${frameId}&itemTypeMasterId=${itemTypeMasterId}&isOurLens=${isOurLens}&companyId=${JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId}`
    );
  }

  /**
   *@name getTinitByFIlterIdBrandMasterIdANDMaterialId
   * @param {number} filterId
   * @param {number} brandMasterId
   * @param {number} materialId
   * @returns
   * @memberof SalesService
   */
  getTinitByFIlterIdBrandMasterIdANDMaterialId(
    filterId: number,
    brandMasterId: number,
    materialId: number,
    indexId: number
  ) {
    return this.customAxios.get(
      `Tint/GetTinitByFIlterIdBrandMasterIdANDMaterialId?filterId=${
        filterId ? filterId : 0
      }&brandMasterId=${brandMasterId ? brandMasterId : 0}&materialId=${
        materialId ? materialId : 0
      }&indexId=${indexId ? indexId : 0}`
    );
  }
  /**
   *@name getTintTypeyFilterBrandIdIndexId
   * @param {number} filterBrandId
   * @param {number} tintMasterId
   * @param {number} indexId
   * @returns
   * @memberof SalesService
   */
   getTintTypeyFilterBrandIdIndexId(
    filterBrandId: number,
    brandMasterId: number,
    materialId: number,
    indexId: number
  ) {
    return this.customAxios.get(
      `TintType/GetTintTypeyFilterBrandIdIndexId?filterBrandId=${
        filterBrandId ? filterBrandId : 0
      }&indexId=${indexId ? indexId : 0}&brandMasterId=${brandMasterId ? brandMasterId : 0}&materialId=${materialId ? materialId : 0}`
    );
  }

  
  /**
   *@name getCTPrice
   * @param {number} ctValue
   * @param {number} customerId
   * @param {number} brandMasterId
   * @param {number} materialId
   * @returns
   * @memberof SalesService
   */
  getCTPrice(
    ctValue: number,
    customerId: number,
    brandMasterId?: number,
    materialId?: number
  ) {
    return this.customAxios.get(
      `ServicePricing/GetCTPrice?ctValue=${ctValue}&customerId=${customerId}&brandMasterId=${
        brandMasterId ? brandMasterId : 0
      }&materialId=${materialId ? materialId : 0}&companyId=${JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId}`
    );
  }

  /**
   *@name getETPrice
   * @param {number} etValue
   * @param {number} customerId
   * @param {number} brandMasterId
   * @param {number} materialId
   * @returns
   * @memberof SalesService
   */
  getETPrice(
    etValue: number,
    customerId: number,
    brandMasterId?: number,
    materialId?: number
  ) {
    return this.customAxios.get(
      `ServicePricing/GetETPrice?etValue=${etValue}&customerId=${customerId}&brandMasterId=${
        brandMasterId ? brandMasterId : 0
      }&materialId=${materialId ? materialId : 0}&companyId=${JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId}`
    );
  }

  /**
   *@name getBaseCurvePrice
   * @param {number} baseCurveValue
   * @param {number} customerId
   * @param {number} brandMasterId
   * @param {number} materialId
   * @returns
   * @memberof SalesService
   */
  getBaseCurvePrice(
    baseCurveValue: number,
    customerId: number,
    brandMasterId?: number,
    materialId?: number
  ) {
    return this.customAxios.get(
      `ServicePricing/GetBaseCurvePrice?baseCurveValue=${baseCurveValue}&customerId=${customerId}&brandMasterId=${
        brandMasterId ? brandMasterId : 0
      }&materialId=${materialId ? materialId : 0}&companyId=${JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId}`
    );
  }

  /**
   *@name getMirrorPrice
   * @param {number} mirrorId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getMirrorPrice(mirrorId: number, customerId: number) {
    return this.customAxios.get(
      `ServicePricing/GetMirrorPrice?mirrorId=${mirrorId}&customerId=${customerId}&companyId=${JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId}`
    );
  }

  /**
   *@name getDecentrationPrice
   * @param {number} decentrationValue
   * @param {number} customerId
   * @param {number} brandMasterId
   * @param {number} materialId
   * @returns
   * @memberof SalesService
   */
  getDecentrationPrice(
    decentrationValue: number,
    customerId: number,
    brandMasterId?: number,
    materialId?: number
  ) {
    return this.customAxios.get(
      `ServicePricing/GetDecentrationPrice?decentrationValue=${decentrationValue}&customerId=${customerId}&brandMasterId=${
        brandMasterId ? brandMasterId : 0
      }&materialId=${materialId ? materialId : 0}&companyId=${JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId}`
    );
  }

  /**
   *@name getOtherService
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getOtherService(
    customerId: number,
    brandMasterId: number,
    materialId: number,
    focalId: number
  ) {
    return this.customAxios.get(
      `ServicePricing/GetOtherService?customerId=${customerId}&brandMasterId=${brandMasterId}&materialId=${materialId}&focalId=${focalId}&companyId=${JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId}`
    );
  }

  /**
   * @name filterAllItemCatalogs
   * @param payload
   * @method GET
   * @return Promise
   */
  filterAllItemCatalogs(payload: any) {
    return this.customAxios.get(
      `ItemCatalog/FilterAllItemCatalogs?MaterialId=${
        payload.materialId
      }&FocalId=${payload.focalId}&BrandMasterId=${
        payload.brandMasterId
      }&SubBrandMasterId=${
        payload.subBrandMasterId ? payload.subBrandMasterId : 0
      }&ItemTypeMasterId=${
        payload.itemTypeMasterId ? payload.itemTypeMasterId : 0
      }&FilterId=${payload.filterId ? payload.filterId : 0}&IndexId=${
        payload.indexId ? payload.indexId : 0
      }&IsOurLens=${payload.isOurLens ? payload.isOurLens : false}`
    );
  }

   /**
   * @name filterAllItemCatalogsByCustomer
   * @service InventoryService
   * @param payload
   * @method get
   * @return Promise
   */
    filterAllItemCatalogsByCustomer(payload: any) {
      return this.customAxios.get(
        `ItemCatalog/FilterAllItemCatalogsByCustomer?MaterialId=${
          payload.materialId
        }&FocalId=${payload.focalId}&BrandMasterId=${
          payload.brandMasterId
        }&SubBrandMasterId=${
          payload.subBrandMasterId ? payload.subBrandMasterId : 0
        }&ItemTypeMasterId=${
          payload.itemTypeMasterId ? payload.itemTypeMasterId : 0
        }&FilterId=${payload.filterId ? payload.filterId : 0}&IndexId=${
          payload.indexId ? payload.indexId : 0
        }&IsOurLens=${payload.isOurLens ? payload.isOurLens : false}&CustomerId=${payload.customerId ? payload.customerId : 0}`
      );
    }


  /**
   * @name getAllItemCatalogsByGrouping
   * @service InventoryService
   * @param payload
   * @method POST
   * @return Promise
   */
  getAllItemCatalogsByGrouping(payload: any) {
    return this.customAxios.get(
      `ItemCatalog/GetAllItemCatalogsByGrouping?MaterialId=${
        payload.materialId
      }&FocalId=${payload.focalId}&BrandMasterId=${
        payload.brandMasterId
      }&SubBrandMasterId=${
        payload.subBrandMasterId ? payload.subBrandMasterId : 0
      }&ItemTypeMasterId=${
        payload.itemTypeMasterId ? payload.itemTypeMasterId : 0
      }&FilterId=${payload.filterId ? payload.filterId : 0}&IndexId=${
        payload.indexId ? payload.indexId : 0
      }`
    );
  }

  /**
   * @name getAllItemCatalogGroup
   * @service InventoryService
   * @param payload
   * @method GET
   * @return Promise
   */
  getAllItemCatalogGroup(payload: any) {
    return this.customAxios.get(
      `ItemCatalog/GetAllItemCatalogGroup?MaterialId=${
        payload.materialId
      }&FocalId=${payload.focalId}&BrandMasterId=${
        payload.brandMasterId
      }&FilterId=${payload.filterId ? payload.filterId : 0}&IndexId=${
        payload.indexId ? payload.indexId : 0
      }&IsOurLens=${payload.isOurLens ? payload.isOurLens : false}`
    );
  }

    /**
   * @name getAllItemCatalogGroupByCustomerId
   * @service sales servie
   * @param payload
   * @method GET
   * @return Promise
   */
     getAllItemCatalogGroupByCustomerId(payload: any) {
      return this.customAxios.get(
        `ItemCatalog/GetAllItemCatalogGroupByCustomerId?MaterialId=${
          payload.materialId
        }&FocalId=${payload.focalId}&BrandMasterId=${
          payload.brandMasterId
        }&FilterId=${payload.filterId ? payload.filterId : 0}&IndexId=${
          payload.indexId ? payload.indexId : 0
        }&IsOurLens=${payload.isOurLens ? payload.isOurLens : false}&CustomerId=${payload.customerId ? payload.customerId : 0}`
      );
    }
  /**
   * @name getLensSidesByItemCatalogId
   * @param {number}  itemCatalogId
   * @return Availible Lense
   * @description fetch Lense
   */
  getLensSidesByItemCatalogId(itemCatalogId: number) {
    return this.customAxios.get(
      "LensSide/GetLensSidesByItemCatalogId?itemCatalogId=" + itemCatalogId
    );
  }

  /**
   * @name getLensSidesByside
   * @param {boolean}  isBarcodeSingleSide
   * @return Availible Lense
   * @description fetch Lense
   */
  getLensSidesByside(isBarcodeSingleSide: boolean) {
    return this.customAxios.get("LensSide/GetLensSidesByside?isSS=" + isBarcodeSingleSide);
  }

  /**
   *@name getAllCustomerBrand
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getAllCustomerBrand(customerId: number) {
    return this.customAxios.get(
      `CustomerBrand/GetCustomerBrandByCustomerId?customerId=${customerId}`
    );
  }

  /**
   * @name updateCustomerBrand
   * @method POST
   * @return Promise
   */
  updateCustomerBrand(payload: any) {
    return this.customAxios.post("CustomerBrand/UpdateBrandMaster", payload);
  }

  /**
   *@name getAllCustomerSubBrand
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getAllCustomerSubBrand(customerId: number) {
    return this.customAxios.get(
      `CustomerSubBrand/GetCustomerSubBrandByCustomerId?customerId=${customerId}`
    );
  }

  /**
   * @name updateCustomerBrand
   * @method POST
   * @return Promise
   */
  updateCustomerSubBrand(payload: any) {
    return this.customAxios.post("CustomerSubBrand/UpdateCustomerSubBrand", payload);
  }

  /**
   * @name getAllPricingTypes
   * @method GET
   * @return Promise
   */
  getAllPricingTypes() {
    return this.customAxios.get("PricingType/GetAllPricingTypes");
  }

  /**
   * @name getAllCustomerBusinessTypes
   * @method GET
   * @return Promise
   */
  getAllCustomerBusinessTypes() {
    return this.customAxios.get("CustomerBusinessType/GetAllCustomerBusinessTypes");
  }

  /**
   *@name getAllCustomerBusinessLine
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getAllCustomerBusinessLine(customerId: number) {
    return this.customAxios.get(
      `CustomerBusinessLine/GetAllCustomerBusinessLine?customerId=${customerId}`
    );
  }

  /**
   * @name addCustomerBusinessLine
   * @method POST
   * @return Promise
   */
  addCustomerBusinessLine(payload: any) {
    return this.customAxios.post("CustomerBusinessLine/AddCustomerBusinessLine", payload);
  }

  /**
   * @name getAllOtherServiesByFilter
   * @method GET
   * @param {number} brandMasterId
   * @param {number} materialId
   * @param {number} focalId
   * @return Promise
   */
  getAllOtherServiesByFilter(
    brandMasterId: number,
    materialId: number,
    focalId: number
  ) {
    return this.customAxios.get(
      `OtherService/GetAllOtherServiesByFilter?brandMasterId=${brandMasterId}&materialId=${materialId}&focalId=${focalId}`
    );
  }

  /**
   * @name getMirrorList
   * @method GET
   * @param {number} brandMasterId
   * @param {number} materialId
   * @return Promise
   */
  getMirrorList(brandMasterId: number, materialId: number) {
    return this.customAxios.get(
      `Mirror/GetMirrorList?brandMasterId=${brandMasterId}&materialId=${materialId}`
    );
  }

  /**
   * @name getCatalogGroupDetailByItemCatalogId
   * @param itemCatalogId
   * @returns Promise
   * @description Currency item
   */
  getCatalogGroupDetailByItemCatalogId(itemCatalogGroupId: number) {
    return this.customAxios.get(
      `CatalogGroup/GetCatalogGroupDetailByItemCatalgGroupId?itemCatalogGroupId=${itemCatalogGroupId}`
    );
  }

  /**
   * @name getAvailableStock
   * @param ItemCatalogId, Sph, CylOrAdd
   * @returns Promise
   * @description returns available quantity
   */
  getAvailableStock(
    itemCatalogId: any,
    itemTypeMasterId: any,
    focalId: any,
    companyBranchId: any,
    sph: any,
    cyl: any,
    add: any,
    cx: any
  ) {
    // return this.customAxios.get(`StockRequest/GetAvailableStock?ItemCatalogId=${ItemCatalogId}&Sph=${Sph}&CylOrAdd=${CylOrAdd}`);
    return this.customAxios.get(
      `AvailableStock/GetAvailableQTY?ItemCatalogId=${itemCatalogId}&ItemTypeMasterId=${itemTypeMasterId}&FocalId=${focalId}&CompanyBranchId=${companyBranchId}&SPH=${sph}&CYL=${cyl}&ADDF=${add}&Cx=${cx}`
    );
  }

  /**
   * @name checkBlockedCustomer
   * @param customerId, paymentTypeId
   * @returns Promise
   * @description checks if user is blocked
   */
  checkBlockedCustomer(customerId: any, paymentTypeId: any) {
    // return this.customAxios.get(`StockRequest/GetAvailableStock?ItemCatalogId=${ItemCatalogId}&Sph=${Sph}&CylOrAdd=${CylOrAdd}`);
    return this.customAxios.get(
      `CustomerPaymentTerm/CustomerPaymentTermValidation?customerId=${customerId}&paymentTypeId=${paymentTypeId}`
    );
  }

  /**
   * @name getBarcodeListForFNStock
   * @param ItemCatalogId, Sph, CylOrAdd
   * @returns Promise
   * @description returns available quantity
   */
  getBarcodeListForFNStock(
    lensSideId: any,
    itemCatalogGroupId: any,
    sph: any,
    cyl: any,
    add: any
  ) {
    // return this.customAxios.get(`StockRequest/GetAvailableStock?ItemCatalogId=${ItemCatalogId}&Sph=${Sph}&CylOrAdd=${CylOrAdd}`);
    return this.customAxios.get(
      `VendorItemCatalog/GetBarcodeListForFNStock?lensSideId=${lensSideId}&itemCatalogGroupId=${itemCatalogGroupId}&sph=${sph}&cyl=${cyl}&add=${add}`
    );
  }

  /**
   * @name getInvoiceableCustomers
   * @param {number} companyBranchId
   * @returns Promise
   * @description fetch Customers
   */
  getInvoiceableCustomers(
    companyBranchId: number,
    customerTypeId: number,
    customerDate: any,
    includeDateFilter: boolean
  ) {
    return this.customAxios.get(
      `Invoice/GetInvoiceableCustomers?companyBranchId=${companyBranchId}&customerTypeId=${customerTypeId}&customerDate=${customerDate}&includeDateFilter=${includeDateFilter}`
    );
  }

  /**
   * @name getItemCatalogPowerRange
   * @param {number} itemCatalogId, focalId
   * @returns Promise
   * @description fetch power ranges
   */
  getItemCatalogPowerRange(itemCatalogId: number, focalId: number) {
    return this.customAxios.get(
      `ItemCatalog/GetItemCatalogPowerRange?itemCatalogId=${itemCatalogId}&focalId=${focalId}`
    );
  }

  /**
   * @name generateReport
   * @param {number} payload,
   * @returns Promise
   * @description fetch power ranges
   */
  generateReport(payload: any) {
    return this.customAxios.post("Report/GenerateReport", payload);
  }

  /**
   * @name getAllItemCatalogRanges
   * @param {number} companyId, itemTypeMasterId, brandId, focalId, indexId, materialId, extraRange
   * @returns Promise
   * @description fetch power ranges
   */
  getAllItemCatalogRanges(
    companyId: number,
    itemTypeMasterId: number,
    brandId: number,
    focalId: number,
    indexId: number,
    materialId: number,
    extraRange: any,
    companyBranchId: number
  ) {
    return this.customAxios.get(
      `ItemCatalogRange/GetAllItemCatalogRanges?companyId=${companyId}&itemTypeMasterId=${itemTypeMasterId}&brandId=${brandId}&focalId=${focalId}&indexId=${indexId}&materialId=${materialId}&extraRange=${extraRange}&companyBranchId=${companyBranchId}`
    );
  }

  /**
   * @name getItemTypeByMaterialId
   * @param {event}  materialId
   * @param {number} countryId
   * @return itemTypesList
   * @description fetch item type list by material Id
   *
   */
  getItemTypeByMaterialId(countryId, materialId) {
    return this.customAxios.get(
      "ItemType/GetAllItemTypeByMaterialId?materialId=" +
        materialId +
        "&countryId=" +
        countryId
    );
  }

  /**
   * @name getItemCatalog
   * @param {itemCatalogGroupId}  itemCatalogGroupId
   * @param {itemSizeId} itemSizeId
   * @return itemcatalog data
   * @description fetch item type list by itemSizeId
   *
   */
  getItemCatalog(itemCatalogGroupId: number, itemSizeId: number) {
    return this.customAxios.get(
      "ItemCatalog/GetItemCatalog?itemCatalogGroupeId=" +
        itemCatalogGroupId +
        "&itemSizeId=" +
        itemSizeId
    );
  }

  /**
   * @name getFocalByItemTypeMasterId
   * @param {event}  itemTypeMasterId
   * @return focalIdsList
   * @description fetch data by id
   *
   */
  getFocalByItemTypeMasterId(itemTypeMasterId) {
    return this.customAxios.get(
      "Focal/GetFocalsByItemTypeMasterId?itemTypeMasterId=" + itemTypeMasterId
    );
  }

  /**
   * @name getItemCatalogSizeByBarcode
   * @param {any} filterPayload
   */
  getItemCatalogSizeByBarcode(filterPayload: any) {
    return this.customAxios.get(
      "ItemCatalog/GetItemCatalogSizeByBarcode?&SPH=" +
        filterPayload.sph +
        "&CYL=" +
        filterPayload.cyl +
        "&ADDF=" +
        filterPayload.addf +
        "&BrandMasterId=" +
        filterPayload.brandMasterId +
        "&SubBrandId=" +
        filterPayload.subBrandMasterId +
        "&FocalId=" +
        filterPayload.focalId +
        "&ColorMasterId=" +
        filterPayload.colorMasterId +
        "&MaterialId=" +
        filterPayload.materialId +
        "&CorridorId=" +
        filterPayload.corridorId +
        "&ItemTypeMasterId=" +
        filterPayload.itemTypeMasterId +
        "&FilterBrandId=" +
        filterPayload.filterBrandId +
        "&IndexId=" +
        filterPayload.indexId +
        "&FilterId=" +
        filterPayload.filterId +
        "&IsBarcodeSingleSide=" +
        filterPayload.IsBarcodeSingleSide +
        "&DesignTechId=" +
        filterPayload.designTechId
    );
  }

  /**
   * @name getGroupSize
   * @param {any} filterPayload
   */

  getGroupSize(filterPayload: any) {
    return this.customAxios.get(
      "ItemCatalog/GetGroupSize?&sph=" +
        filterPayload.sph +
        "&cyl=" +
        filterPayload.cyl +
        "&addf=" +
        filterPayload.addf +
        "&focalId=" +
        filterPayload.focalId +
        "&itemCatalogGroupeId=" +
        filterPayload.itemCatalogGroupId
    );
  }

  /**
   * @name getGroupSizeByitemCatalogGroupeId
   * @param {number} itemCatalogGroupeId
   */

  getGroupSizeByitemCatalogGroupeId(itemCatalogGroupeId: number) {
    return this.customAxios.get(
      "ItemCatalog/getGroupSizeByitemCatalogGroupeId?&itemCatalogGroupeId=" +
        itemCatalogGroupeId
    );
  }

  /**
   * @name getAllVendorItemCatalogMasterByCatalogId
   * @param itemCatalogId
   * @retur Promise
   */
  getAllVendorItemCatalogMasterByCatalogId(itemCatalogId) {
    return this.customAxios.get(
      `VendorItemCatalog/GetAllVendorItemCatalogMasterByCatalogId?catalogId=${itemCatalogId}`
    );
  }

  /**
   * @name getPowerRange
   * @param itemCatalogId
   * @retur Promise
   */
  getPowerRange(itemCatalogId) {
    return this.customAxios.get(
      `VendorItemCatalog/GetPowerRange?catalogId=${itemCatalogId}`
    );
  }

  /**
   * @name getAllFrameBrands
   * @method GET
   * @return Promise
   */
  getAllFrameBrands() {
    return this.customAxios.get("FrameBrand/GetAllFrameBrands");
  }

  /**
   * @name getAllShapes
   * @return Promise
   * @description fetch all Shapes
   */
  getAllShapes() {
    return this.customAxios.get(`Shape/GetAllShapes`);
  }

  /**
   * @name getAllFreightChargeByVendorAndCountry
   * @param {number} vendorId, countryId
   * @returns Promise
   * @description fetch freight charges by courier id and country id
   */
  getAllFreightChargeByVendorAndCountry(vendorId: number, countryId: number) {
    return this.customAxios.get(
      `FreightCharge/GetAllFreightChargeByVendorAndCountry?vendorId=${vendorId}&countryId=${countryId}`
    );
  }

  /**
   * @name getAllLensSidesByFocalId
   * @param {number} focalId
   * @returns Promise
   * @description fetch lense side
   */
  getAllLensSidesByFocalId(focalId: number) {
    return this.customAxios.get(`LensSide/GetAllLensSidesByFocalId?focalId=${focalId}`);
  }

  /**
   * @name getAllFreightChargeTo
   * @param
   * @returns Promise
   * @description get freight charge to list
   */
  getAllFreightChargeTo() {
    return this.customAxios.get(`FreightCharge/GetAllFreightChargeTo`);
  }

  /**
   * @name checkSalesOrderStockIssuanceComplete
   * @param {number} salesOrderId
   * @returns boolean
   * @description true false
   */
  checkSalesOrderStockIssuanceComplete(salesOrderId: number) {
    return this.customAxios.get(
      `SalesOrderStockIssue/CheckSalesOrderStockIssuanceComplete?salesOrderId=` +
        salesOrderId
    );
  }

  /**
   * @name isValidatePONumber
   * @param {string} poNumber
   * @param {number} customerId
   * @returns boolean
   * @description true false
   */
  isValidatePONumber(poNumber: string, customerId: number) {
    return this.customAxios.get(
      `SalesOrder/IsValidatePONumber?poNumber=${poNumber}&customerId=${customerId}`
    );
  }

  /**
   * @name getAllBrandMastersExceptZeiss
   * @param
   * @returns Promise
   * @description get BrandMaster charge to list
   */
  getAllBrandMastersExceptZeiss() {
    return this.customAxios.get(`BrandMaster/GetAllBrandMastersExceptZeiss`);
  }

  /**
   * @name getItemsForStockIssuence
   * @method POST
   * @return Promise
   */
  getItemsForStockIssuence(payload: any) {
    return this.customAxios.post("VendorItemCatalog/GetItemsForStockIssuence", payload);
  }

  /**
   *@name getAllCustomerFlatDiscounts
   * @param {number} customerId
   * @param {number} companyId
   * @returns
   * @memberof SalesService
   */
  getAllCustomerFlatDiscounts(customerId: number, companyId: number) {
    return this.customAxios.get(
      `CustomerFlatDiscount/GetAllCustomerFlatDiscounts?customerId=${customerId}&companyId=${companyId}`
    );
  }

  /**
   * @name addCustomerFlatDiscountLine
   * @method POST
   * @return Promise
   */
  addCustomerFlatDiscountLine(payload: any) {
    return this.customAxios.post("CustomerFlatDiscount/AddCustomerFlatDiscount", payload);
  }

  /**
   * @name getAllCompanyBranches
   * @returns Promise
   * @description fetch all item
   */
  getAllcompanyBranches() {
    return this.customAxios.get(`CompanyBranch/GetAllCompanyBranches`);
  }

  /**
   * @name GetAllBrandMasters
   * @returns Promise
   * @description fetch all Brand
   */
  GetAllBrandMasters() {
    return this.customAxios.get(`BrandMaster/GetAllBrandMasters`);
  }

  /**
   * @name GetAllSubBrandsByBrandMasterId
   * @params {number} brandMasterId
   * @returns Promise
   * @description fetch record
   */
  getAllSubBrandsByBrandMasterId(brandMasterId: number) {
    return this.customAxios.get(
      `SubBrand/GetAllSubBrandsByBrandMasterId?brandMasterId=${brandMasterId}`
    );
  }

  /**
   * @name getAllSalesOrderType
   * @params
   * @returns Promise
   * @description fetch record
   */
  getAllSalesOrderType() {
    return this.customAxios.get(`SalesOrderType/GetAllSalesOrderTypes`);
  }

  /**
   * @name getAllResult
   * @returns fetch all reasons
   */
  getAllResult() {
    return this.customAxios.get("Result/GetAllResults");
  }

  /**
   * @name getProductionInquiryList
   * @param payload
   * @returns Promise
   * @description fetch record
   */
  getProductionInquiryList(payload: any) {
    return this.customAxios.post(`Production/GetProductionInquiryList`, payload);
  }

  /**
   * @name getSalesInquiryList
   * @param payload
   * @returns Promise
   * @description fetch record
   */
  getSalesInquiryList(payload: any) {
    return this.customAxios.post(`SalesOrder/GetSalesInquiry`, payload);
  }

  
  /**
   * @name getCustomerSalesInquiry
   * @param payload
   * @returns Promise
   * @description fetch record
   */
   getCustomerSalesInquiry(payload: any) {
    // return this.customAxios.post(`SalesOrder/GetCustomerSalesInquiry`, payload);
    return this.customAxios.post(`SalesOrder/GetSalesInquiry`, payload);
  }

  /**
   * @name getFittingInquiry
   * @param payload
   * @returns Promise
   * @description fetch record
   */
  getFittingInquiry(payload: any) {
    return this.customAxios.post(`SalesOrderFrameFitting/GetFittingInquiry`, payload);
  }

  /**
   * @name getPendingOrders
   * @param {number} companyBranchId
   * @returns Promise
   * @description fetch record
   */
  getPendingOrders(companyBranchId: number) {
    return this.customAxios.get(
      `SalesOrder/GetPendingOrders?companyBranchId=${companyBranchId}`
    );
  }

  /**
   * @name getSTOPendingOrders
   * @param {number} companyBranchId
   * @returns Promise
   * @description fetch record
   */
  getSTOPendingOrders(companyBranchId: number) {
    return this.customAxios.get(
      `SalesOrder/GetSTOPendingOrders?companyBranchId=${companyBranchId}`
    );
  }

  /**
   * @name addCSPPowerRange
   * @method POST
   * @return Promise
   */
  addCSPPowerRange(payload: any) {
    return this.customAxios.post("CSPPowerRange/AddCSPPowerRange", payload);
  }

  /**
   * @name addCSPPowerRangeList
   * @method POST
   * @return Promise
   */
  addCSPPowerRangeList(payload: any) {
    return this.customAxios.post("CSPPowerRange/AddCSPPowerRangeList", payload);
  }

  /**
   * @name addBranchAcknowledgement
   * @method POST
   * @return Promise
   */
  addBranchAcknowledgement(payload: any) {
    return this.customAxios.post(
      "BranchAcknowledgement/AddBranchAcknowledgement",
      payload
    );
  }
  /**
   * @name getStockIndex
   * @param {number} materialId
   * @method GET
   * @return Promise
   */
  getStockIndex(materialId: number) {
    return this.customAxios.get("Index/GetStockIndex?materialId=" + materialId);
  }
  /**
   * @name getFrameForSalesOrder
   * @param {number} ItemCatalogGroupId
   * @method GET
   * @return Promise
   */
  getFrameForSalesOrder(ItemCatalogGroupId: number) {
    return this.customAxios.get(
      "FrameType/GetFrameForSalesOrder?ItemCatalogGroupId=" + ItemCatalogGroupId
    );
  }

  /**
   * @name getAllRxReasonsByProcessId
   * @returns fetch all reasons according to process id
   */
  getAllRxReasonsByProcessIdAndResultId(processId: number, resultId: number) {
    return this.customAxios.get(
      "RxReason/GetRxReasonByResultId?processId=" +
        processId +
        "&resultId=" +
        resultId
    );
  }
  /**
   * @name getSalesOrderDetailForLW
   * @params
   * @returns Promise
   * @description fetch SalesOrder lw data
   */
  getSalesOrderDetailForLW(salesOrderId: number) {
    return this.customAxios.get(
      `SalesOrder/GetSalesOrderDetailForLW?salesOrderId=${salesOrderId}`
    );
  }
  /**
   * @name getBrandMasterByCategoryId
   * @params {number} itemCategoryId
   * @returns Promise
   * @description fetch Brand List
   */
  getBrandMasterByCategoryId(itemCategoryId: number) {
    return this.customAxios.get(
      `BrandMaster/GetBrandMasterByCategoryId?itemCategoryId=${itemCategoryId}`
    );
  }

  /**
   * @name getBrandMasterByCategoryId
   * @params {number} itemCategoryId
   * @param {number} customerId
   * @returns Promise
   * @description fetch Brand List
   */
   getCustomerBrandMasterByCategoryId(itemCategoryId: number, customerId: number) {
    return this.customAxios.get(
      `BrandMaster/GetCustomerBrandMasterByCategoryId?itemCategoryId=${itemCategoryId}&customerId=${customerId ? customerId : 0}`
    );
  }
  


  /**
   * @name getAllMaterialsByCategory
   * @params {number} itemCategoryId
   * @returns Promise
   * @description fetch Brand List
   */
  getAllMaterialsByCategory(itemCategoryId: number) {
    return this.customAxios.get(
      `Material/GetAllMaterialsByCategory?itemCategoryId=${itemCategoryId}`
    );
  }
  /**
   * @name getAllFrames
   * @returns Promise
   * @description fetch frame types
   */
  getAllFrames() {
    return this.customAxios.get(`Frame/GetAllFrames`);
  }

  registerTabIndex() {
    window.onkeypress = (e) => {
      if (e.which == 13) {
        e.preventDefault();
        let $inputs = $("input[tabIndex]");
        let input = (<any>document).activeElement;
        let numList = $inputs.map(function (o, i) {
          let num = i.tabIndex;
          return num;
        });
        let maxTabIndex = Math.max(...numList);
        let tabMissed = this.focusInput($inputs, input, 0);
        while (tabMissed > 0 && !(tabMissed > maxTabIndex)) {
          let newTabIndex = tabMissed + 1;
          tabMissed = this.focusInput($inputs, input, newTabIndex);
        }
      }
    };
  }

  focusInput(inputs, input, newTabIndex) {
    let missedTabIndex = 0;
    let tabIndexFound = false;
    for (let index = 0; index < inputs.length; index++) {
      let nextTabIndex = newTabIndex == 0 ? input.tabIndex + 1 : newTabIndex;
      missedTabIndex = nextTabIndex;
      if (
        inputs[index].tabIndex == nextTabIndex &&
        inputs[index].disabled == false
      ) {
        inputs[index].focus();
        tabIndexFound = true;
        break;
      }
    }
    if (!tabIndexFound) {
      return missedTabIndex;
    } else {
      return 0;
    }
  }

  /**
   * @name validateSalesOrder
   * @method POST
   * @return Promise
   * @description validation for dublicate sale order checking
   */
  validateSalesOrder(payload: any) {
    return this.customAxios.post("SalesOrder/ValidateSalesOrder", payload);
  }

  /**
   * @name isComplainApproved
   * @method GET
   * @param {number} salesOrderId
   * @return Promise
   * @description validation for dublicate sale order checking
   */
  isComplainApproved(salesOrderId: any) {
    return this.customAxios.get(
      "SalesOrderComplain/IsComplainApproved?salesOrderId=" + salesOrderId
    );
  }

  /**
   * @name getAllCompanys
   * @method get
   * @return Promise
   * @description get all company list
   */
  getAllCompanys() {
    return this.customAxios.get("Company/GetAllCompanys");
  }

  /**
   * @name getAllItemCategories
   * @method get
   * @return Promise
   * @description get all categories list
   */
  getAllItemCategories() {
    return this.customAxios.get("ItemCategory/GetAllItemCategories");
  }

  /**
   * @name getAllItemSizes
   * @method get
   * @return Promise
   * @description get all item size list
   */
  getAllItemSizes() {
    return this.customAxios.get("ItemSize/GetAllItemSizes");
  }

  /**
   * @name getAllVendors
   * @method get
   * @return Promise
   * @description get all vendors list
   */
  getAllVendors() {
    return this.customAxios.get("Vendor/GetAllVendors");
  }

  /**
   * @name getVendorByItemCategoryId
   * @method get
   * @return Promise
   * @param itemCategoryId
   * @description get all vendors list by itemCategoryId
   */
  getVendorByItemCategoryId(itemCategoryId: any) {
    return this.customAxios.get(
      `Vendor/GetVendorByItemTypeCategoryId?itemCategoryId=${itemCategoryId}`
    );
  }

  /**
   * @name getAllVendors
   * @method get
   * @return Promise
   * @description get all vendors list
   */
  getAllFrameColors() {
    return this.customAxios.get("FrameColor/GetAllFrameColors");
  }

  /**
   * @name getAllFrameColorsByVendorIdAndFrameBrandId
   * @param vendorId, frameBrandId
   * @method get
   * @return Promise
   * @description get all vendors list
   */
  getAllFrameColorsByVendorIdAndFrameBrandId(
    vendorId: number,
    frameBrandId: number
  ) {
    return this.customAxios.get(
      "FrameColor/GetAllInventoryFrameColors?vendorId=" +
        vendorId +
        "&frameBrandId=" +
        frameBrandId
    );
  }

  /**
   * @name getAllItemSizeByVendorIdAndFrameBrandId
   * @param vendorId, frameBrandId
   * @method get
   * @return Promise
   * @description get all vendors list
   */
  getAllItemSizeByVendorIdAndFrameBrandId(
    vendorId: number,
    frameBrandId: number
  ) {
    let vendor = vendorId ? vendorId : 0;
    let frameBrand = frameBrandId ? frameBrandId : 0;
    return this.customAxios.get(
      "ItemSize/GetAllInventoryFrameSize?vendorId=" +
        vendor +
        "&frameBrandId=" +
        frameBrand
    );
  }

  /**
   * @name getInventoryCatalogForMisSalesOrder
   * @method get
   * @return Promise
   * @description get all inventory catalog list
   */
  getInventoryCatalogForMisSalesOrder(payload: any) {
    return this.customAxios.get(
      "InventoryCatalog/GetInventoryCatalogForMisSalesOrder?Barcode=" +
        payload.barcode +
        "&ItemCategoryId=" +
        payload.itemCategoryId +
        "&SubCategoryId=" +
        payload.subCategoryId +
        "&VednorId=" +
        payload.vendorId +
        "&FrameBrandId=" +
        payload.brandMasterId +
        "&ModelId=" +
        payload.modelId +
        "&FrameColorId=" +
        payload.colorMasterId +
        "&ItemSizeId= " +
        payload.itemSizeId +
        "&CustomerId= " +
        payload.customerId
    );
  }

  /**
   * @name addSalesOrderOther
   * @method POST
   * @return Promise
   */
  addSalesOrderOther(payload: any, salesOrderId?: number) {
    if (salesOrderId) {
      return this.customAxios.post("SalesOrderOthers/UpdateSalesOrderOther", payload);
    } else {
      return this.customAxios.post("SalesOrderOthers/AddSalesOrderOther", payload);
    }
  }

  /**
   * @name getAllSalesOrderBySalesOrderId
   * @param {number} salesOrderId
   * @returns Promise
   * @description fetch all item
   */
  getMiscSalesOrderBySalesOrderId(salesOrderId) {
    return this.customAxios.get(
      `SalesOrderOthers/GetMiscOrdersById?salesOrderId=` + salesOrderId
    );
  }

  /**
   * @name deleteSalesOrderOthers
   * @param salesOrderId
   * @returns Promise
   * @description fetch all item
   */
  deleteSalesOrderOthers(salesOrderOtherId: number) {
    return this.customAxios.get(
      `SalesOrderOthers/DeleteSalesOrder?salesOrderOtherId=${salesOrderOtherId}`
    );
  }

  /**
   * @name getCustomerBranchByCustomerId
   * @param customerId
   * @returns Promise
   * @description fetch all item
   */
  getCustomerBranchByCustomerId(customerId: number) {
    return this.customAxios.get(
      `CustomerBranch/GetCustomerBranchByCustomerId?customerId=${customerId}`
    );
  }
  /**
   * @name getAllFrameBrandsByVendorId
   * @param vendorId
   * @returns Promise
   * @description fetch all item
   */
  getAllFrameBrandsByVendorId(vendorId: number) {
    return this.customAxios.get(
      `FrameBrand/GetAllFrameBrandsByVendorId?vendorId=${vendorId}`
    );
  }

  /**
   * @name getModelByVendorAndFrameBrand
   * @param vendorId
   * @param frameBrandId
   * @returns Promise
   * @description fetch all item
   */
  getModelByVendorAndFrameBrand(vendorId: number, frameBrandId: number) {
    return this.customAxios.get(
      `Model/GetModelByVendorAndFrameBrand?vendorId=${vendorId}&frameBrandId=${frameBrandId}`
    );
  }

  /**
   * @name getPrice
   * @param itemCatalogId
   * @param customerId
   * @returns Promise
   * @description fetch all item
   */
  getPrice(
    itemCatalogId: number,
    customerId: number,
    companyBranchId: number,
    cityId: number
  ) {
    return this.customAxios.get(
      `ItemCatalog/GetPrice?itemCatalogId=${itemCatalogId}&customerId=${customerId}&companyBranchId=${companyBranchId}&cityId=${cityId}`
    );
  }

  /**
   * @name AddSalesOrderTransfer
   * @method POST
   * @return Promise
   */
  AddSalesOrderTransfer(payload: any) {
    return this.customAxios.post("StockTransfer/AddStockTransfer", payload);
  }

  /**
   * @name getSubCategoryByParentId
   * @param {number} itemCategoryId
   * @returns Promise
   * @description fetch all item
   */
  getSubCategoryByParentId(itemCategoryId: number) {
    return this.customAxios.get(
      `SubCategory/GetubCategoryByCategoryId?itemCategoryId=${itemCategoryId}`
    );
  }

  /**
   * @name generateStockOrderTransferReport
   * @param {number} salesOrderId
   * @returns Promise
   * @description Generate Sale order Report
   */
  generateStockOrderTransferReport(salesOrderId: number) {
    return this.customAxios.get(
      `Report/GenerateStockOrderTransferReport?salesOrderId=` + salesOrderId
    );
  }

  /**
   * @name getCustomerFlatDiscountById
   * @param {number} customerFlatDiscountId
   * @returns Promise
   * @description get customer flat discount by id
   */
  getCustomerFlatDiscountById(customerFlatDiscountId: number) {
    return this.customAxios.get(
      `CustomerFlatDiscount/GetCustomerFlatDiscountById?customerFlatDiscountId=` +
        customerFlatDiscountId
    );
  }

  /**
   * @name getAllStockRequestNotIssue
   * @param {number} companyBranchId
   * @returns Promise
   * @description get item by company branch
   */
  getAllStockRequestNotIssue(companyBranchId: number) {
    return this.customAxios.get(
      `StockRequest/GetAllStockRequestNotIssue?branchId=` + companyBranchId
    );
  }

  /**
   * @name deleteCustomerFlatDiscountById
   * @param {number} customerFlatDiscountId
   * @returns Promise
   * @description delete customer flat discount by id
   */
  deleteCustomerFlatDiscount(customerFlatDiscountId: number) {
    return this.customAxios.get(
      `CustomerFlatDiscount/DeleteFlatDiscount?customerFlatDiscountId=` +
        customerFlatDiscountId
    );
  }

  /**
   * @name addCustomerFlatDiscount
   * @method POST
   * @return Promise
   */
  addCustomerFlatDiscount(payload: any, editCustomerFlatDiscount?: any) {
    if (editCustomerFlatDiscount) {
      return this.customAxios.post("CustomerFlatDiscount/UpdateCustomerDiscount", payload);
    } else {
      return this.customAxios.post("CustomerFlatDiscount/AddCustomerDiscount", payload);
    }
  }
  /**
   * @name updateSalesOrderLensRemarks
   * @method POST
   * @return Promise
   */
  updateSalesOrderLensRemarks(payload: any) {
    return this.customAxios.post("SalesOrderLens/UpdateSalesOrderLensRemarks", payload);
  }

  /**
   * @name getAllDiscountAt
   * @method get
   * @return Promise
   * @description get all discount at
   */
  getAllDiscountAt() {
    return this.customAxios.get("DiscountAt/GetAllDiscountAt");
  }

  /**
   * @name getAllEdger
   * @returns Promise
   * @description fetch all Customer Type
   */

  getAllEdger() {
    return this.customAxios.get(`Edger/GetAllEdgers`);
  }

  /**
   * @name getSalesOrdersForStockRequestByCreatedByBranchId
   * @param {number} createdByBranchId
   * @returns Promise
   * @description fetch sales data
   */
   getSalesOrdersForStockRequestByCreatedByBranchId(createdByBranchId: number) {
    return this.customAxios.get(
      `SalesOrder/GetSalesOrdersForStockRequestByCreatedByBranchId?createdByBranchId=${createdByBranchId ? createdByBranchId : 0}`
    );
  }

 /**
   * @name validateCustomerPaymentTerm
   * @param {number} customerId
   * @returns Promise
   * @description customer validation limit
   */
  validateCustomerPaymentTerm(customerId: number, customerBranchId: any) {
    return this.customAxios.get(
      `CustomerPaymentTerm/ValidateCustomerPaymentTerm?customerId=${
        customerId ? customerId : 0
      }&customerBranchId=${customerBranchId ? customerBranchId : 0}`
    );
  }

  getCustomerBrandMaster(customerId: number, isRx: boolean, isStock: boolean, isOther: boolean) {
    return this.customAxios.get(
      `BrandMaster/GetCustomerBrandMaster?customerId=${customerId}&isRx=${isRx}&isStock=${isStock}&isOther=${isOther}`
    );
  }
  getAllSubBrandMasterByBrandMasterId(brandMasterId: number) {
    return this.customAxios.get(
      `SubBrandMaster/GetAllSubBrandMasterByBrandMasterId?brandMasterId=${brandMasterId}`
    );
  }

  

getAllCompanyBranchesByUserId(userId: number, companyId: number, isAdministrator: boolean) {
   return this.customAxios.get(
     `CompanyBranch/GetAllCompanyBranchesByUserId?userId=${userId}&companyId=${companyId}&isAdministrator=${isAdministrator}`
   );
 }
}
